// extracted by mini-css-extract-plugin
module.exports = {"backBtn":"news-post-module--back-btn--1DgEf","backBtn@md":"news-post-module--back-btn-md--1YkC9","btnContainer":"news-post-module--btn-container--sok4x"};